import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useTranslation } from '../hooks/useTranslation';
import { ChevronDown, ChevronUp, X } from 'lucide-react';

const ClientsSection = () => {
  const { t, language } = useTranslation();
  const [showAllClients, setShowAllClients] = useState(false);

  // Client data generated from public/clients folder (filename -> client name)
  const clients = [
    { name: 'Hilton', enName: 'Hilton', logo: `${process.env.PUBLIC_URL}/clients/Hilton.jpeg` },
    { name: 'Borg El Arab', enName: 'Borg El Arab', logo: `${process.env.PUBLIC_URL}/clients/Borg El Arab.jpeg` , instagram: 'https://www.instagram.com/borgelarabbeachhotel/'},
    { name: 'Sharm Dreams Group', enName: 'Sharm Dreams Group', logo: `${process.env.PUBLIC_URL}/clients/sharmdreamsgroup.jpeg` },
    { name: 'Old Palace', enName: 'Old Palace', logo: `${process.env.PUBLIC_URL}/clients/Old Palace.jpeg` , instagram: 'https://www.instagram.com/resortoldpalace/'},
    { name: 'JAZ Hotel Group', enName: 'JAZ Hotel Group', logo: `${process.env.PUBLIC_URL}/clients/JAZ.jpg` },
    { name: 'Azimut', enName: 'Azimut', logo: `${process.env.PUBLIC_URL}/clients/Azimut.jpeg` , instagram: 'https://www.instagram.com/azimutegypt/'},
    { name: 'Snap Magnet', enName: 'Snap Magnet', logo: `${process.env.PUBLIC_URL}/clients/Snap Magnet.jpeg`},

    { name: 'Fame Maker', enName: 'Fame Maker', logo: `${process.env.PUBLIC_URL}/clients/FMmaker.jpeg` },
    { name: 'Slick Management', enName: 'Slick Management', logo: `${process.env.PUBLIC_URL}/clients/Slick Management.jpeg` , instagram: 'https://www.instagram.com/slickmanagement/'},
    { name: 'Loopers Management', enName: 'Loopers Management', logo: `${process.env.PUBLIC_URL}/clients/Loopers Management.jpeg` },
    { name: 'Ahmed Morshed - Investment Coach', enName: 'Ahmed Morshed - Investment Coach', logo: `${process.env.PUBLIC_URL}/clients/Ahmed Morshed - Investment Coach.jpeg`, instagram: 'https://www.instagram.com/elmorshed1?igsh=aTc4aGZmYzh1b3Jv'  },
    { name: 'Games Spot', enName: 'Games Spot', logo: `${process.env.PUBLIC_URL}/clients/Games Spot.jpeg`, instagram: 'https://www.instagram.com/gamesspoteg/' },


  { name: 'Zowail', enName: 'Zowail', logo: `${process.env.PUBLIC_URL}/clients/Zowail.jpeg`, instagram: 'https://www.instagram.com/zowaill/' },
  { name: 'Mohamed Amin', enName: 'Mohamed Amin', logo: `${process.env.PUBLIC_URL}/clients/Mohamed Amin.jpeg`, instagram: 'https://www.instagram.com/mohmedaminn/' },
  { name: 'Nour Badr', enName: 'Nour Badr', logo: `${process.env.PUBLIC_URL}/clients/Nour Badr.jpeg`, instagram: 'https://www.instagram.com/nourbadr_11/?hl=en' },
  { name: 'Haleem', enName: 'Haleem', logo: `${process.env.PUBLIC_URL}/clients/Haleem.png`, instagram: 'https://www.instagram.com/haleem_official/?hl=en' },
  { name: 'Waleed Mostafa', enName: 'Waleed Mostafa', logo: `${process.env.PUBLIC_URL}/clients/Waleed Mostafa.jpeg`, instagram: 'https://www.instagram.com/waleedmostafa00/?hl=en' },

  { name: 'Aya Shoieb', enName: 'Aya Shoieb', logo: `${process.env.PUBLIC_URL}/clients/Aya Shoieb.jpeg`, instagram: 'https://www.instagram.com/ayashoaibpage/?hl=en' },
  { name: 'Ramzy Mahmoud', enName: 'Ramzy Mahmoud', logo: `${process.env.PUBLIC_URL}/clients/Ramzy Mahmoud.jpeg`, instagram: 'https://www.instagram.com/ramzy.mahmoud_1/?hl=en' },
  { name: 'Ahmed Abaza', enName: 'Ahmed Abaza', logo: `${process.env.PUBLIC_URL}/clients/Ahmed Abaza.jpeg`, instagram: 'https://www.instagram.com/lifewithabaza/' },
  { name: 'Sara Haitham', enName: 'Sara Haitham', logo: `${process.env.PUBLIC_URL}/clients/Sara Haitham.jpeg`, instagram: 'https://www.instagram.com/sarahaytham1/?hl=en' },
  { name: 'Nada Hassan', enName: 'Nada Hassan', logo: `${process.env.PUBLIC_URL}/clients/Nada Hassan.jpeg`, instagram: 'https://www.instagram.com/nada.hassan.official/' },

  { name: 'Arwa kassem', enName: 'Arwa kassem', logo: `${process.env.PUBLIC_URL}/clients/Arwa Hassan.jpeg`, instagram: 'https://www.instagram.com/arwakassem129/' },
  { name: 'Mohamed Khabiery', enName: 'Mohamed Khabiery', logo: `${process.env.PUBLIC_URL}/clients/Mohamed Khabiery.jpeg`, instagram: 'https://instagram.com/mohamedkhabiery' },
  { name: 'Sandra Kadrii', enName: 'Sandra Kadrii', logo: `${process.env.PUBLIC_URL}/clients/Sandra Kadrii.jpeg`, instagram: 'https://www.instagram.com/sandrakadri/' },
  { name: 'Nadia El Kholy', enName: 'Nadia El Kholy', logo: `${process.env.PUBLIC_URL}/clients/Nadia El Kholy.jpeg`, instagram: 'https://www.instagram.com/nadia.elkholy/' },
  { name: 'Aziz Elakkad', enName: 'Aziz Elakkad', logo: `${process.env.PUBLIC_URL}/clients/Aziz Elakkad.jpeg`, instagram: 'https://www.instagram.com/azizelakkaad/' },

  { name: 'Reham Anany', enName: 'Reham Anany', logo: `${process.env.PUBLIC_URL}/clients/Reham Anany.jpeg`, instagram: 'https://www.instagram.com/reham_anany/' },
  { name: 'Ahmed Ibrahim', enName: 'Ahmed Ibrahim', logo: `${process.env.PUBLIC_URL}/clients/Ahmed Ibrahim.png`, instagram: 'https://www.instagram.com/ahmeedibrahimm/' },
  { name: 'Nour Ehab', enName: 'Nour Ehab', logo: `${process.env.PUBLIC_URL}/clients/Nour Ehab.jpeg`, instagram: 'https://www.instagram.com/nourehab/' },
  { name: 'Dina El Khattam', enName: 'Dina El Khattam', logo: `${process.env.PUBLIC_URL}/clients/Dina El Khattam.jpeg`, instagram: 'https://www.instagram.com/deenaelkhattam/' },
  { name: 'Georgiana Tawaf', enName: 'Georgiana Tawaf', logo: `${process.env.PUBLIC_URL}/clients/Georgiana Tawaf.jpeg`, instagram: 'https://www.instagram.com/georgianatawaf/' },

  { name: 'Menna Ehab', enName: 'Menna Ehab', logo: `${process.env.PUBLIC_URL}/clients/Menna Ehab.jpeg`, instagram: 'https://www.instagram.com/mennaehab33/' },
  { name: 'Sameer Sobhi', enName: 'Sameer Sobhi', logo: `${process.env.PUBLIC_URL}/clients/Sameer Sobhi.jpeg`, instagram: 'https://www.instagram.com/sameersobhi/' },
  { name: 'Aysel Khaled', enName: 'Aysel Khaled', logo: `${process.env.PUBLIC_URL}/clients/Aysel Khaled.jpeg`, instagram: 'https://www.instagram.com/ayselkhaledofficial/' },
  { name: 'Ghada Hassan', enName: 'Ghada Hassan', logo: `${process.env.PUBLIC_URL}/clients/Ghada Hassan.jpeg`, instagram: 'https://www.instagram.com/ghadahassan25/' },
  { name: 'Rewan Alaa', enName: 'Rewan Alaa', logo: `${process.env.PUBLIC_URL}/clients/Rewan Alaa.jpeg`, instagram: 'https://www.instagram.com/rewanalaaa/' },

  { name: 'Rahaf Elshamii', enName: 'Rahaf Elshamii', logo: `${process.env.PUBLIC_URL}/clients/Rahaf Elshamii.jpeg`, instagram: 'https://www.instagram.com/rahafelshamiofficial/' },
  { name: 'Lobna Wanas', enName: 'Lobna Wanas', logo: `${process.env.PUBLIC_URL}/clients/Lobna Wanas.jpeg`, instagram: 'https://www.instagram.com/lobnawanasofficial/' },
  { name: 'Nada Alaa', enName: 'Nada Alaa', logo: `${process.env.PUBLIC_URL}/clients/Nada Alaa.jpeg`, instagram: 'https://www.instagram.com/nadaalaa949/' },
  { name: 'Gehad Elbanna', enName: 'Gehad Elbanna', logo: `${process.env.PUBLIC_URL}/clients/Gehad Elbanna.jpeg`, instagram: 'https://www.instagram.com/gehad.elbanaa/' },
  { name: 'Amal Reda', enName: 'Amal Reda', logo: `${process.env.PUBLIC_URL}/clients/Amal Reda.jpeg`, instagram: 'https://www.instagram.com/amal_aboalmgd/' },

  { name: 'Zeinab Hassan', enName: 'Zeinab Hassan', logo: `${process.env.PUBLIC_URL}/clients/Zeinab Hassan.jpeg`, instagram: 'https://instagram.com/zeinabhassan' },
  { name: 'Esha', enName: 'Esha', logo: `${process.env.PUBLIC_URL}/clients/Esha.jpeg`, instagram: 'https://www.instagram.com/m.esha14/' },
  { name: 'Youssef Omar', enName: 'Youssef Omar', logo: `${process.env.PUBLIC_URL}/clients/Youssef Omar.jpeg`, instagram: 'https://www.instagram.com/yousseffomar1/' },

];

  const featuredClients = clients.filter((client) => [
    'Hilton',
    'Slick Management',
    'Azimut',
    'Loopers Management',
    'Old Palace',
    'Borg El Arab',
    'JAZ Hotel Group',
    'Snap Magnet'
  ].includes(client.enName));

  const toggleShowAllClients = () => {
    setShowAllClients(!showAllClients);
  };

  // Animation variants for smoother transitions
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.05,
        delayChildren: 0.1
      }
    },
    exit: {
      opacity: 0,
      transition: {
        staggerChildren: 0.05,
        staggerDirection: -1
      }
    }
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        stiffness: 100
      }
    },
    exit: {
      y: -20,
      opacity: 0,
      transition: {
        duration: 0.2
      }
    }
  };

  return (
    <section id="clients" className="py-16 bg-gradient-to-b from-white to-gray-50 dark:from-gray-900 dark:to-gray-800">
      <div className="container mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-12">
          <motion.h2 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-4xl md:text-5xl font-bold mb-4 bg-gradient-to-r from-[#A37A00] to-amber-700 bg-clip-text text-transparent"
          >
            {language === 'ar' ? 'عملاؤنا الكرام' : 'Our Valued Clients'}
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="text-lg text-gray-600 dark:text-gray-300 max-w-2xl mx-auto"
          >
            {language === 'ar' 
              ? 'نحن فخورون بشراكتنا مع مؤسسات متميزة تسعى نحو التميز المالي'
              : 'We are proud to partner with distinguished institutions striving for financial excellence'}
          </motion.p>
        </div>

        {/* Conditional Rendering */}
        <div className="relative overflow-hidden py-4 clients-carousel-container min-h-[400px]">
          {!showAllClients ? (
            <motion.div
              variants={containerVariants}
              initial="hidden"
              animate="visible"
              exit="exit"
              className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-6"
            >
              {featuredClients.map((client, index) => (
                <a
                  key={index}
                  href={client.instagram || '#'}
                  target={client.instagram ? '_blank' : undefined}
                  rel={client.instagram ? 'noopener noreferrer' : undefined}
                  className={client.instagram ? 'group block transition-transform hover:-translate-y-1' : 'block'}
                >
                  <motion.div
                    variants={itemVariants}
                    className="flex flex-col items-center justify-center p-6 bg-white dark:bg-gray-800 rounded-3xl shadow-xl hover:shadow-2xl transition-all duration-300 h-full"
                  >
                    <div className="relative w-28 h-24 mb-4">
                      <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-gray-100 to-gray-200 dark:from-gray-700 dark:to-gray-800 rounded-xl">
                        <div className="w-17 h-17 rounded-full bg-gradient-to-br from-amber-500 to-amber-700 flex items-center justify-center overflow-hidden">
                          {client.logo ? (
                            <img
                              src={client.logo}
                              alt={client.enName}
                              className="w-full h-full object-contain p-0.5"
                              onError={(e) => {
                                e.target.style.display = 'none';
                                e.target.parentElement.innerHTML = `
                                  <span class="text-white font-bold text-2xl">
                                    ${client.enName.charAt(0)}
                                  </span>
                                `;
                              }}
                            />
                          ) : (
                            <span className="text-white font-bold text-2xl">
                              {client.enName.charAt(0)}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                    <p className="text-center text-sm font-medium text-gray-700 dark:text-gray-200 mt-2 line-clamp-2">
                      {client.enName}
                    </p>
                  </motion.div>
                </a>
              ))}
            </motion.div>
          ) : (
            <motion.div
              variants={containerVariants}
              initial="hidden"
              animate="visible"
              exit="exit"
              className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-6 clients-grid-container"
            >
              {clients.map((client, index) => (
                <a
                  key={index}
                  href={client.instagram || '#'}
                  target={client.instagram ? '_blank' : undefined}
                  rel={client.instagram ? 'noopener noreferrer' : undefined}
                  className={client.instagram ? 'group block transition-transform hover:-translate-y-1' : 'block'}
                >
                  <motion.div
                    variants={itemVariants}
                    className="flex flex-col items-center justify-center p-4 bg-white dark:bg-gray-800 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105 h-full"
                  >
                    <div className="relative w-28 h-20 mb-3">
                      <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-gray-100 to-gray-200 dark:from-gray-700 dark:to-gray-800 rounded-lg">
                        <div className="w-16 h-16 rounded-full bg-gradient-to-br from-amber-500 to-amber-700 flex items-center justify-center overflow-hidden">
                          {client.logo ? (
                            <img 
                              src={client.logo} 
                              alt={client.enName}
                              className="w-full h-full object-contain p-1"
                              onError={(e) => {
                                e.target.style.display = 'none';
                                e.target.parentElement.innerHTML = `
                                  <span class="text-white font-bold text-xl">
                                    ${client.enName.charAt(0)}
                                  </span>
                                `;
                              }}
                            />
                          ) : (
                            <span className="text-white font-bold text-xl">
                              {client.enName.charAt(0)}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                    <p className="text-center text-xs sm:text-sm font-medium text-gray-700 dark:text-gray-200 mt-2 line-clamp-2">
                      {client.enName}
                    </p>
                  </motion.div>
                </a>
              ))}
            </motion.div>
          )}
        </div>

        {/* Show More/Less Button */}
        <div className="text-center clients-button-container mt-8">
          <motion.button
            onClick={toggleShowAllClients}
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
            className="flex items-center gap-2 mx-auto px-8 py-3 bg-gradient-to-r from-[#A37A00] to-amber-700 text-white rounded-full font-medium hover:shadow-lg transition-shadow show-clients-btn"
          >
            {showAllClients ? (
              <>
                {language === 'ar' ? 'عرض أقل' : 'Show Less'}
                <ChevronUp size={20} />
              </>
            ) : (
              <>
                {language === 'ar' ? 'عرض جميع العملاء' : 'Show All Clients'}
                <ChevronDown size={20} />
              </>
            )}
          </motion.button>
          <p className="text-gray-500 dark:text-gray-400 text-sm mt-2">
            {showAllClients
              ? language === 'ar'
                ? 'انقر لإخفاء جميع العملاء'
                : 'Click to hide all clients'
              : language === 'ar'
                ? 'انقر لعرض جميع العملاء'
                : 'Click to view all clients'}
          </p>
        </div>

        {/* Close button for all clients view (mobile-friendly) */}
        <AnimatePresence>
          {showAllClients && (
            <motion.div
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, scale: 0.8 }}
              className="fixed bottom-20 right-6 z-40 md:hidden"
            >
              <button
                onClick={toggleShowAllClients}
                className="p-3 bg-red-500 text-white rounded-full shadow-lg hover:bg-red-600 transition-colors"
                aria-label={language === 'ar' ? 'إغلاق' : 'Close'}
              >
                <X size={24} />
              </button>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </section>
  );
};

export default ClientsSection;